import { FC } from 'react';
import PhoneInputBase, { formatPhoneNumberIntl, Value } from 'react-phone-number-input';
import './styles.scss';

const PhoneInput = PhoneInputBase as any;

type Props = {
  value?: Value;
  onChange?: (val: any) => void;
  placeholder?: string;
};

const PhoneNumberField: FC<Props> = (props: Props) => {
  const { value, onChange, placeholder } = props;
  return (
    <PhoneInput
      className="custom-phone-input"
      defaultCountry="VN"
      placeholder={placeholder}
      value={formatPhoneNumberIntl(value) as Value}
      onChange={onChange}
    />
  );
};

export default PhoneNumberField;
